﻿export const disqualifyReasons = [
  'Incomplete',
  'Ineligible',
  'Foreign language',
  'Insufficient detail',
  'Other',
] as const;

export type ScrubbingStatusType = 'Passed' | 'Disqualified' | 'Pending' | 'Pending-Disqualified';
export type DisqualifyReasonType = (typeof disqualifyReasons)[number];

export const ScrubbingStatusId: Record<ScrubbingStatusType, number> = {
  Passed: 1,
  Disqualified: 2,
  Pending: 3,
  'Pending-Disqualified': 4,
};

export interface NominationScrubbingStatus {
  nominationId: number;
  scrubbingStatus?: ScrubbingStatusType;
  disqualifyReason?: DisqualifyReasonType;
  feedback?: string;
}

export function blankNominationScrubbingStatus(): NominationScrubbingStatus {
  return {
    nominationId: 0,
    scrubbingStatus: undefined,
    disqualifyReason: undefined,
    feedback: undefined
  };
}
